import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

export function BBBDressCode() {
  return (
    <div className="py-16 bg-gradient-to-b from-transparent to-pink-950/20  bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-pink-300/10"
        >
          <div className="flex items-center justify-center mb-8">
            <div className="w-16 h-16 bg-pink-500/10 rounded-full flex items-center justify-center">
              <Sparkles className="w-8 h-8 text-pink-300" />
            </div>
          </div>

          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Dress Code</h2>
            <p className="text-xl text-pink-300 mb-6">A touch of pink</p>
            {/* <p className="text-gray-400 max-w-2xl mx-auto">
              Join us in creating a beautiful atmosphere by incorporating pink into your outfit. 
              Whether it's a subtle accent or a bold statement, let's celebrate together in style!
            </p> */}
          </div>
        </motion.div>
      </div>
    </div>
  );
}